"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonetaryText = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const text_1 = __importDefault(require("./text"));
const Superscript = styled_components_1.default.sup `
  font-size: 0.5em;
  line-height: 0;
`;
const Small = styled_components_1.default.span `
  font-size: 0.5em;
`;
const MonetaryText = (_a) => {
    var { value, variant = 'decimal', currencyLocation = 'before', currencySymbol = '$', suffix = undefined, locales } = _a, textProps = __rest(_a, ["value", "variant", "currencyLocation", "currencySymbol", "suffix", "locales"]);
    if (!Number.isInteger(value)) {
        throw Error('Value in MonetaryText must be an integer');
    }
    let parsedNumber = value / 100;
    if (variant === 'round') {
        parsedNumber = Math.round(parsedNumber);
    }
    else if (variant === 'round-up') {
        parsedNumber = Math.ceil(parsedNumber);
    }
    else if (variant === 'superscript' || variant === 'round-down') {
        parsedNumber = Math.trunc(parsedNumber);
    }
    const digits = variant === 'decimal' ? 2 : 0;
    const formattedNumber = parsedNumber.toLocaleString(locales, {
        minimumFractionDigits: digits,
    });
    const superscript = (value - parsedNumber * 100).toString().padEnd(2, '0');
    return (react_1.default.createElement(text_1.default, Object.assign({}, textProps),
        currencyLocation === 'before' && currencySymbol,
        currencyLocation === 'superscript' && (react_1.default.createElement(Superscript, null, currencySymbol)),
        formattedNumber,
        variant === 'superscript' && react_1.default.createElement(Superscript, null, superscript),
        currencyLocation === 'after' && ` ${currencySymbol}`,
        suffix && react_1.default.createElement(Small, null, ` ${suffix}`)));
};
exports.MonetaryText = MonetaryText;
exports.default = exports.MonetaryText;
